import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Result, Button, Steps, Typography, Divider } from "antd";
import { usePreference } from "../context/PreferenceContext";
import {
    ShoppingOutlined,
    UnorderedListOutlined,
    InboxOutlined,
    CodeSandboxOutlined,
    CarOutlined
} from "@ant-design/icons";
import "../css/OrderSuccessPage.css";
import Navbar from "./Navbar";

const { Title, Text } = Typography;
const { Step } = Steps;

const OrderSuccessPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { formatPrice } = usePreference();

    const orderId = location.state?.orderId || "N/A";
    const totalAmount = location.state?.totalAmount || 0;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />

            <div className="order-success-web-container">
                <Result
                    status="success"
                    title={<Title level={2}>Order Placed Successfully!</Title>}
                    subTitle={
                        <div className="order-success-subtitle">
                            <Text className="pcu-font-16 pcu-color-muted">
                                Thank you for your purchase. Your order has been received and is currently being processed.
                            </Text>
                            <div className="order-summary-box">
                                <Text strong className="pcu-font-16">Order ID: #{orderId}</Text>
                                <Divider type="vertical" />
                                <Text strong className="pcu-font-16" type="success">Total: {formatPrice(totalAmount)}</Text>
                            </div>
                        </div>
                    }
                    extra={[
                        <Button
                            type="primary"
                            key="orders"
                            size="large"
                            icon={<UnorderedListOutlined />}
                            className="pcu-bg-purple"
                            onClick={() => navigate("/buyer/orders")}
                        >
                            View My Orders
                        </Button>,
                        <Button
                            key="shopping"
                            size="large"
                            icon={<ShoppingOutlined />}
                            onClick={() => navigate("/")}
                        >
                            Continue Shopping
                        </Button>,
                    ]}
                >
                    <div className="order-tracking-steps">
                        <Title level={4} style={{ textAlign: "center", marginBottom: 30 }}>Expected Order Journey</Title>
                        <Steps current={0} responsive>
                            <Step
                                title="Order Received"
                                description="We have received your order"
                                icon={<InboxOutlined />}
                            />
                            <Step
                                title="Being Prepared"
                                description="Your items are being packed"
                                icon={<CodeSandboxOutlined />}
                            />
                            <Step
                                title="On The Way"
                                description="Delivery to your address"
                                icon={<CarOutlined />}
                            />
                        </Steps>
                    </div>
                </Result>
            </div>
        </>
    );
};

export default OrderSuccessPage;
